import styled from 'styled-components';

export const Item = styled.span`
  display: flex;
  align-items: center;

  .icon {
    margin-right: 5px;
  }

  .text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }
`;
